module.exports = __webpack_public_path__ + "img/15.89de4606.jpg";